import { FC } from "react";
import PaginatedList from "../PaginatedList";
import { useSelector } from "react-redux";
import { selectReviews } from "../../../../slices/reviews-slice";
import ReviewCard from "./ReviewCard";
import { useTranslation } from "react-i18next";

interface ReviewListProps {
    uploadReviewsCallback: () => Promise<void>;
    wrapClassName?: string;
}

const ReviewList: FC<ReviewListProps> = (props) => {
    const { t } = useTranslation();
    const reviews = useSelector(selectReviews);

    return (
        <div className={`relative flex flex-col dmin2:w-[737px] ${props.wrapClassName || ""}`}>
            <PaginatedList
                entities={reviews}
                uploadCallback={props.uploadReviewsCallback}
                getItemElement={(review) => <ReviewCard review={review} />}
                emptyEntitiesContent={
                    <div className="flex flex-col items-center">
                        <p className="H24B dmax2:H16B text-textFaded text-center">{t("catalog.nothingFound")}</p>
                    </div>
                }
            />
        </div>
    );
};

export default ReviewList;
